import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '@Container/common/client/utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const navigation = content.map((item, index) => (
            <li key={index}>
                <a href={item.url} target="_blank" rel={rel} title={item.title}>
                    {item.title}
                </a>
            </li>
        ));

        return (
            <div id="navigation" className={styles.col_box}>
                <div className={styles.col_navlist}>
                    <ul className="clearfix">{navigation}</ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Navigation);
